import React, { useState } from "react";
import "./HallOfFame.css";
import { FaAward } from "react-icons/fa6";
import ImageWithSkeleton from "./ImageWithSkeleton";


const awardsList = [
  {
    id: 1,
    name: "Award of Excellence",
    meta: "IIL India · July 2025",
    image: "/assets/hall of fame/1.jpg"
  },
  {
    id: 2,
    name: "Outstanding Performance",
    meta: "Heranba Industries · 2024-25",
    image: "/assets/hall of fame/2.jpg"
  },
  {
    id: 3,
    name: "Product Award – SOFIA",
    meta: "IIL India · July 2025",
    image: "/assets/hall of fame/3.jpg"
  },
  {
    id: 4,
    name: "Product Award – HACHIMAN",
    meta: "IIL India · July 2025",
    image: "/assets/hall of fame/4.jpg"
  },
  {
    id: 5,
    name: "Ratan Club Member",
    meta: "IIL India · 2024-25",
    image: "/assets/hall of fame/5.jpg"
  },
  {
    id: 6,
    name: "Best in Segment Creation",
    meta: "Sumitomo · FY 2020-21",
    image: "/assets/hall of fame/6.jpg"
  },
  {
    id: 7,
    name: "Maharatan Club – Malaysia",
    meta: "IIL India · 2024-25",
    image: "/assets/hall of fame/7.jpg"
  },
  {
    id: 8,
    name: "Award of Appreciation",
    meta: "IIL India · July 2023",
    image: "/assets/hall of fame/8.jpg"
  }
];

const ceremonyPhotos = [
  {
    id: 1,
    title: "Owner with Award at IIL Meet",
    desc: "IIL Annual Distributors Meet · Hotel Crowne Plaza, Ahmedabad · 2025",
    image: "/assets/award/award1.jpeg"
  },
  {
    id: 2,
    title: "IIL Award of Excellence",
    desc: "Hotel Crowne Plaza, Ahmedabad · 2024",
    image: "/assets/award/award2.jpeg"
  },
  {
    id: 3,
    title: "IIL Maharatan Award at Malaysia",
    desc: "IIL Maharatan Club Meet · Malaysia · 2025",
    image: "/assets/award/award3.jpeg"
  }
];

function HallOfFame() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="hall-of-fame-page-container">
      {/* Page Hero Banner */}
      <div className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">🏆 Hall of Fame</h1>
          <p className="page-subtitle">Awards & Recognition received by Vinayak Agro Chemicals</p>
        </div>
      </div>

      {/* Award Count Strip */}
      <div className="award-count-strip">
        <div className="count-strip-content">
          <span className="medal-icon"><FaAward size={24} /></span>
          <span className="count-text">
            <strong>Total Awards Won: 14+</strong> · From IIL, Heranba, Sumitomo & more
          </span>
        </div>
      </div>

      {/* Trophies Section */}
      <section className="trophies-section">
        <div className="trophies-container">
          <span className="section-tag">Trophies & Certificates</span>
          <h2 className="section-title">Awards Gallery</h2>
          <p className="section-subtitle">A testament to our quality service and customer trust</p>
          
          <div className="trophies-grid">
            {awardsList.map((award) => (
              <div 
                key={award.id} 
                className="award-card"
                onClick={() => setSelectedImage(award.image)}
              >
                <div className="award-image-box">
                  <ImageWithSkeleton
                    src={award.image}
                    alt={award.name}
                    className="award-card-img"
                    fallbackIcon="🏆"
                    fallbackClassName="award-fallback"
                  />
                </div>
                <div className="award-info-box">
                  <h3 className="award-name">{award.name}</h3>
                  <p className="award-meta-text">{award.meta}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Owner Ceremony Photos Section */}
      <section className="ceremony-section">
        <div className="ceremony-container">
          <span className="section-tag">Owner Photos</span>
          <h2 className="section-title">Owner Receiving Awards</h2>
          <p className="section-subtitle">Capturing our proudest moments on stage</p>

          <div className="ceremony-grid">
            {ceremonyPhotos.map((photo) => (
              <div 
                key={photo.id} 
                className="ceremony-card"
                onClick={() => setSelectedImage(photo.image)}
              >
                <div className="ceremony-image-box">
                  <ImageWithSkeleton
                    src={photo.image}
                    alt={photo.title}
                    className="ceremony-card-img"
                    fallbackIcon="📸"
                    fallbackClassName="ceremony-fallback"
                  />
                </div>
                <div className="ceremony-info-box">
                  <h3 className="ceremony-title-text">{photo.title}</h3>
                  <p className="ceremony-desc-text">{photo.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedImage(null)}>×</button>
            <img src={selectedImage} alt="Enlarged Award" className="enlarged-img" onError={(e) => {
              e.target.src = '/vac.jpg';
            }} />
          </div>
        </div>
      )}
    </div>
  );
}

export default HallOfFame;
